const LoaderPlugin = {
  install(app) {
    app.config.globalProperties.$loader = {
      show() {
        const loader = document.querySelector('.loader')
        if (!loader) return
        loader.style.display = 'block'
        loader.setAttribute('aria-hidden', 'false')
        document.body.setAttribute('aria-busy', 'true')
      },
      hide() {
        const loader = document.querySelector('.loader')
        if (!loader) return
        loader.style.display = 'none'
        loader.setAttribute('aria-hidden', 'true')
        document.body.removeAttribute('aria-busy')
      },
    }
  },
}

export default LoaderPlugin
  